import { render, staticRenderFns } from "./CircleMarker.vue?vue&type=template&id=48edf67e&"
import script from "./CircleMarker.vue?vue&type=script&lang=js&"
export * from "./CircleMarker.vue?vue&type=script&lang=js&"
import style0 from "./CircleMarker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports